import { Box } from '@material-ui/core';
import { getLoanById } from '@nemuru-eng/js-api-client';
import { useParams } from 'react-router-dom';

import { BorrowerCashInCashOutDetails } from '@/components/modules/BorrowerAccountDetails/BorrowerCashInCashOutDetails';
import { DeclaredIncome } from '@/components/modules/DeclaredIncome/DeclaredIncome';
import { ModuleCorePermissionProps } from '@/config/types';
import { usePageContext } from '@/contexts/PageContext/PageContext';
import { useCache } from '@/hooks/requests/useCache';
import { findCurrentParticipantOnboardingDetailsByOnboardingDetailsId } from '@/utils/findCurrentParticipantOnboardingDetails';
import { withPermissionsModule } from '@/utils/withPermissionsModule';

const PersonalFinance = ({ canEdit = false }: ModuleCorePermissionProps) => {
  const {
    state: { applicationParticipant },
  } = usePageContext();
  const { loanId } = useParams();

  if (!loanId) return null;

  const { data: loan } = useCache(getLoanById, { loanId });

  const onboardingDetails =
    loan &&
    findCurrentParticipantOnboardingDetailsByOnboardingDetailsId({
      loan: loan,
      onboardingDetailsId: applicationParticipant.onboardingDetails?.id,
    });

  if (!loan) return null;

  return (
    <>
      <BorrowerCashInCashOutDetails loan={loan} editModeAllowed={canEdit} />
      <Box mt={3} />
      {onboardingDetails && (
        <DeclaredIncome onboardingDetails={onboardingDetails} loan={loan} editModeAllowed={canEdit} />
      )}
    </>
  );
};

export const PersonalFinanceModule = withPermissionsModule(PersonalFinance);
